import React from 'react';

type BadgeKind =
  | 'success' | 'warning' | 'danger' | 'info'
  | 'neutral' | 'indigo'  | 'teal';

interface BadgeProps {
  kind?:    BadgeKind;
  dot?:     boolean;
  children: React.ReactNode;
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({ kind = 'neutral', dot = false, children, className = '' }) => (
  <span className={`badge ${kind} ${dot ? 'dot' : ''} ${className}`}>{children}</span>
);

// ── Estado badge específico para entidades ────────────────────
const ESTADO_MAP: Record<string, BadgeKind> = {
  'Activo':     'success', 'ACTIVO':    'success', 'PAGADO':    'success',
  'Pagado':     'success', 'EMITIDO':   'success', 'PROMOVIDO': 'success',
  'APROBADO':   'success', 'EJECUTADO': 'success',
  'Pendiente':  'warning', 'PENDIENTE': 'warning', 'Licencia':  'warning',
  'GENERADA':   'warning', 'SOLICITADO': 'warning', 'EN_RECUPERACION': 'warning',
  'Vencido':    'danger',  'VENCIDO':   'danger',  'Suspendido':'danger',
  'Retirado':   'danger',  'ANULADO':   'danger',  'REPITENTE': 'danger',
  'RECHAZADO':  'danger',  'ERROR':     'danger',
  'ENVIADA_UGEL':'info',   'RECTIFICADA':'info',
};

interface EstadoBadgeProps { estado: string; }
export const EstadoBadge: React.FC<EstadoBadgeProps> = ({ estado }) => (
  <Badge kind={ESTADO_MAP[estado] || 'neutral'} dot>{estado}</Badge>
);

// ── Nivel badge (INICIAL/PRIMARIA/SECUNDARIA) ─────────────────
interface NivelBadgeProps { nivel: string; }
export const NivelBadge: React.FC<NivelBadgeProps> = ({ nivel }) => (
  <span className={`badge badge-nivel-${nivel}`}>{nivel}</span>
);
